import ctl from '@netlify/classnames-template-literals';

const buttonStyle = ctl(`
  w-full 
  rounded-sm 
  p-2 
  flex
  items-center
  justify-between 
  bg-bright-gray
`);

const contentStyle = ctl(`
  grid
  overflow-hidden
  transition-all
  duration-300
  ease-in-out
`);

const contentContainerStyle = ctl(`
  overflow-hidden
  bg-white
  rounded-b-sm
`);

export default {
  buttonStyle,
  contentStyle,
  contentContainerStyle,
};
